import { MemoWithCategory } from '@/models/reservation/reservation-note'
import { LanguageType } from '@/i18n'

// 清掃アカウントのヘッダーで選べる言語
export const CleanerLanguages: readonly LanguageType[] = [LanguageType.ja, LanguageType.en]

export type RoomType = {
  guestRoomId: string
  roomNumber: string
  floorNameJa: string
  floorNameEn: string
  cleaningStatus: CleaningStatusType
  roomUsageStatus: RoomUsageStatusType
  cleaningStaffId: string
  adminComment: string
  adminCommentEn?: string
  staffReport: string
  isStayOrScheduleOfStay: boolean
  isCleaningRequired: boolean
  cleanedAt: string | null
  checkList: Array<{ id: number; isChecked: boolean }>
  nextReservation: ReservationType | null
  photos: Array<{ path: string }>
}

// 全体共有。英訳は表示専用で、編集には原文（announce）を使う
export type AnnounceType = {
  announce: string
  announceEn: string
}

export type ReservationType = {
  nights: number
  roomPax: {
    male: number
    female: number
    childA: number
    childB: number
    childC: number
    childD: number
    childE: number
    childF: number
    childOther: number
    total: number
  }
  roomCheckinAt: string
  roomCheckoutAt: string
  notes: MemoWithCategory[]
}

export const CleaningStatusType = {
  Unused: 0,
  NotCleaning: 1,
  Cleaned: 2,
  Inspected: 3,
  DoNotDisturb: 4,
  NotRequired: 5,
} as const
export type CleaningStatusType = (typeof CleaningStatusType)[keyof typeof CleaningStatusType]
export const CleaningStatusValues = {
  [CleaningStatusType.Unused]: '-',
  [CleaningStatusType.NotCleaning]: 'cleaningManager.Dirty',
  [CleaningStatusType.Cleaned]: 'cleaningManager.Clean',
  [CleaningStatusType.Inspected]: 'cleaningManager.Inspected',
  [CleaningStatusType.DoNotDisturb]: 'cleaningManager.Do not Disturb',
  [CleaningStatusType.NotRequired]: 'cleaningManager.No Cleaning',
}

// 選択肢としての表示順（未設定は末尾）
export const CleaningStatusSelectOrder: CleaningStatusType[] = [
  CleaningStatusType.NotCleaning,
  CleaningStatusType.Cleaned,
  CleaningStatusType.Inspected,
  CleaningStatusType.DoNotDisturb,
  CleaningStatusType.NotRequired,
  CleaningStatusType.Unused,
]

export const RoomUsageStatusType = {
  Unused: 1,
  Stay: 2,
  Away: 3,
  CheckOutScheduled: 4,
  CheckedOut: 5,
} as const
export type RoomUsageStatusType = (typeof RoomUsageStatusType)[keyof typeof RoomUsageStatusType]
export const RoomUsageStatusValues = {
  [RoomUsageStatusType.Unused]: 'cleaningManager.Vacant',
  [RoomUsageStatusType.Stay]: 'cleaningManager.Occupied',
  [RoomUsageStatusType.Away]: 'cleaningManager.Out',
  [RoomUsageStatusType.CheckOutScheduled]: 'cleaningManager.Checkout Soon',
  [RoomUsageStatusType.CheckedOut]: 'cleaningManager.Done Checkout',
}

interface langType {
  en: string
  zh: string
  ko: string
  zhTw: string
  ja: string
}
export type CheckListType = {
  id: number
  name: langType
  displayOrder: number
}
export type CheckListFormType = {
  name: string
  displayOrder: number
}
export type StaffSettingType = {
  id: string
  name: string
  displayOrder: number
}
export type StaffType = {
  id: string
  name: string
  displayOrder: number
  assignments: { [key: string]: number } | []
  shifts: string[]
}
export type staffFormType = {
  name: string
  displayOrder: number
}

// フロア番号をキーとし、各フロアのルーム配列を値とするオブジェクト
export type RoomsDataType = {
  [floorNumber: string]: RoomType[]
}

export const RoomSortKey = {
  CheckinAt: 'checkinAt',
  RoomNumber: 'roomNumber',
} as const
export type RoomSortKey = (typeof RoomSortKey)[keyof typeof RoomSortKey]
export const RoomSortKeyValues = {
  [RoomSortKey.CheckinAt]: 'cleaningManager.SortByCheckinAt',
  [RoomSortKey.RoomNumber]: 'cleaningManager.SortByRoomNumber',
}
